'use client';

import { useState } from 'react';
import { useTranslations } from 'next-intl';
import { Button, ButtonSize, ButtonType } from '@nx-frontend/shared/ui/button';
import { Checkbox, CheckboxSize, CheckboxType } from '@nx-frontend/shared/ui/checkbox';
import { UiInput, UiInputView } from '@nx-frontend/shared/ui/input';
import { EditPortalLinkPayload } from '@nx-frontend/shared/types';
import { isValidUrl } from '@nx-frontend/shared/utils';

export const EditPortalLinkPopup = ({ content }: { content: EditPortalLinkPayload }) => {
  const [name, setName] = useState(content.name);
  const [url, setUrl] = useState(content.url);
  const [openInNewTab, setOpenInNewTab] = useState(content.openInNewTab);
  const [urlError, setUrlError] = useState(false);

  const t = useTranslations('webnotes');
  return (
    <div className="inline-flex p-[0] flex-col items-start rounded gap-4">
      <div className="flex flex-col gap-[10px]">
        <div className="w-[356px] ">
          <UiInput
            id="edit-link-name"
            type="text"
            label={t('webnotes-page_name')}
            value={name}
            name="edit_link_name"
            error={false}
            placeholder={t('webnotes-page_name')}
            view={UiInputView.LABEL_TOP}
            onChange={(e) => {
              setName(e.target.value);
            }}
          />
        </div>
        <div className="w-[356px] ">
          <UiInput
            id="edit-link-url"
            type="url"
            label="Url"
            value={url}
            name="edit_link_url"
            error={urlError}
            placeholder="https://"
            view={UiInputView.LABEL_TOP}
            onChange={(e) => {
              if (!isValidUrl(e.target.value)) {
                setUrlError(true);
              } else {
                setUrlError(false);
              }
              setUrl(e.target.value);
            }}
          />
        </div>
        <Checkbox
          id="index"
          checked={openInNewTab}
          labelSmall={true}
          label="Open in new tab"
          type={CheckboxType.SWITCH}
          boxSize={CheckboxSize.SM}
          onChange={(checked) => {
            setOpenInNewTab(checked);
          }}
        />
      </div>
      <div className="w-full flex justify-end gap-[12px]">
        <Button
          size={ButtonSize.SM}
          type={ButtonType.FLAT}
          onClick={() => !urlError && content.onSave(name, url, openInNewTab)}
        >
          Save
        </Button>
        <Button size={ButtonSize.SM} type={ButtonType.STROKED} onClick={content.onWantToClose}>
          Cancel
        </Button>
      </div>
    </div>
  );
};
